
import * as antlr from "antlr4ng";
import { Token } from "antlr4ng";


export class GeoTortueLexer extends antlr.Lexer {
    public static readonly GT_FORWARD = 1;
    public static readonly GT_BACKWARD = 2;
    public static readonly GT_TURN_RIGHT = 3;
    public static readonly GT_TURN_LEFT = 4;
    public static readonly GT_CLEAR_GRAPHICS = 5;
    public static readonly GT_RESET = 6;
    public static readonly GT_UNDO_DRAWING = 7;
    public static readonly GT_HIDE_TURTLE = 8;
    public static readonly GT_SHOW_TURTLE = 9;
    public static readonly GT_PEN_UP = 10;
    public static readonly GT_PEN_DOWN = 11;
    public static readonly GT_PEN_COLOR = 12;
    public static readonly GT_PEN_THICKNESS = 13;
    public static readonly GT_DRAW_POINT = 14;
    public static readonly GT_MIRROR = 15;
    public static readonly GT_TELEPORT = 16;
    public static readonly GT_COMPASS = 17;
    public static readonly GT_AIM = 18;
    public static readonly GT_MIMIC = 19;
    public static readonly GT_ROTATE_RIGHT = 20;
    public static readonly GT_ROTATE_LEFT = 21;
    public static readonly GT_ROTATE_UP = 22;
    public static readonly GT_ROTATE_DOWN = 23;
    public static readonly GT_ROTATE_XY = 24;
    public static readonly GT_ROTATE_XZ = 25;
    public static readonly GT_ROTATE_YZ = 26;
    public static readonly GT_DRAW_CIRCLE = 27;
    public static readonly GT_DRAW_ARC = 28;
    public static readonly GT_PLAY = 29;
    public static readonly GT_SCORE = 30;
    public static readonly GT_CONCERT = 31;
    public static readonly GT_FILL = 32;
    public static readonly GT_WRITE = 33;
    public static readonly GT_SAY = 34;
    public static readonly GT_INIT = 35;
    public static readonly GT_WAIT = 36;
    public static readonly GT_PAUSE = 37;
    public static readonly GT_STOP = 38;
    public static readonly GT_RETURN = 39;
    public static readonly GT_MANIPULATE_GRAPH = 40;
    public static readonly GT_SNAPSHOT = 41;
    public static readonly GT_EXECUTE = 42;
    public static readonly GT_DELETE = 43;
    public static readonly GT_GLOBAL = 44;
    public static readonly GT_DISPLAY = 45;
    public static readonly GT_WRAP = 46;
    public static readonly GT_WINDOW = 47;
    public static readonly GT_FENCE = 48;
    public static readonly GT_REPEAT = 49;
    public static readonly GT_WHILE = 50;
    public static readonly GT_FOR_EACH = 51;
    public static readonly GT_FROM = 52;
    public static readonly GT_TO = 53;
    public static readonly GT_IN_LIST = 54;
    public static readonly GT_IF = 55;
    public static readonly GT_THEN = 56;
    public static readonly GT_ELSE = 57;
    public static readonly GT_SELECT = 58;
    public static readonly GT_FUNCTION_DEF = 59;
    public static readonly GT_ASK_FOR_VALUE = 60;
    public static readonly GT_PROCEDURE_START = 61;
    public static readonly GT_PROCEDURE_END = 62;
    public static readonly GT_IDENTIFIER = 63;
    public static readonly GT_WORD = 64;
    public static readonly GT_INTEGER_LITERAL = 65;
    public static readonly GT_FLOATING_POINT_LITERAL = 66;
    public static readonly GT_STRING_LITERAL = 67;
    public static readonly GT_STATEMENT_SEPARATOR = 68;
    public static readonly GT_ASSIGN = 69;
    public static readonly GT_COMMA = 70;
    public static readonly GT_LEFT_SQUARE_BRACKET = 71;
    public static readonly GT_RIGHT_SQUARE_BRACKET = 72;
    public static readonly GT_LEFT_PARENTHESIS = 73;
    public static readonly GT_RIGHT_PARENTHESIS = 74;
    public static readonly GT_COLON = 75;
    public static readonly GT_GREATER_THAN = 76;
    public static readonly GT_LESS_THAN = 77;
    public static readonly GT_EQUAL = 78;
    public static readonly GT_LESS_OR_EQUAL = 79;
    public static readonly GT_GREATER_OR_EQUAL = 80;
    public static readonly GT_NOT_EQUAL = 81;
    public static readonly GT_LOGICAL_AND = 82;
    public static readonly GT_LOGICAL_OR = 83;
    public static readonly GT_PLUS = 84;
    public static readonly GT_MINUS = 85;
    public static readonly GT_MULTIPLY = 86;
    public static readonly GT_DOT = 87;
    public static readonly GT_DIVIDE = 88;
    public static readonly GT_MODULO = 89;
    public static readonly GT_LOGICAL_NOT = 90;
    public static readonly GT_POWER = 91;
    public static readonly GT_CROSS_PRODUCT = 92;
    public static readonly GT_NEW_LINE = 93;
    public static readonly GT_HORIZONTAL_WHITESPACE = 94;
    public static readonly GT_LINE_COMMENT_HASH = 95;
    public static readonly GT_LINE_COMMENT_SLASH = 96;
    public static readonly GT_BLOCK_COMMENT = 97;

    public static readonly channelNames = [
        "DEFAULT_TOKEN_CHANNEL", "HIDDEN"
    ];

    public static readonly literalNames = [
        null, "'GT_FORWARD'", "'GT_BACKWARD'", "'GT_TURN_RIGHT'", "'GT_TURN_LEFT'", 
        "'GT_CLEAR_GRAPHICS'", "'GT_RESET'", "'GT_UNDO_DRAWING'", "'GT_HIDE_TURTLE'", 
        "'GT_SHOW_TURTLE'", "'GT_PEN_UP'", "'GT_PEN_DOWN'", "'GT_PEN_COLOR'", 
        "'GT_PEN_THICKNESS'", "'GT_DRAW_POINT'", "'GT_MIRROR'", "'GT_TELEPORT'", 
        "'GT_COMPASS'", "'GT_AIM'", "'GT_MIMIC'", "'GT_ROTATE_RIGHT'", "'GT_ROTATE_LEFT'", 
        "'GT_ROTATE_UP'", "'GT_ROTATE_DOWN'", "'GT_ROTATE_XY'", "'GT_ROTATE_XZ'", 
        "'GT_ROTATE_YZ'", "'GT_DRAW_CIRCLE'", "'GT_DRAW_ARC'", "'GT_PLAY'", 
        "'GT_SCORE'", "'GT_CONCERT'", "'GT_FILL'", "'GT_WRITE'", "'GT_SAY'", 
        "'GT_INIT'", "'GT_WAIT'", "'GT_PAUSE'", "'GT_STOP'", "'GT_RETURN'", 
        "'GT_MANIPULATE_GRAPH'", "'GT_SNAPSHOT'", "'GT_EXECUTE'", "'GT_DELETE'", 
        "'GT_GLOBAL'", "'GT_DISPLAY'", "'GT_WRAP'", "'GT_WINDOW'", "'GT_FENCE'", 
        "'GT_REPEAT'", "'GT_WHILE'", "'GT_FOR_EACH'", "'GT_FROM'", "'GT_TO'", 
        "'GT_IN_LIST'", "'GT_IF'", "'GT_THEN'", "'GT_ELSE'", "'GT_SELECT'", 
        "'GT_FUNCTION_DEF'", "'GT_ASK_FOR_VALUE'", "'GT_PROCEDURE_START'", 
        "'GT_PROCEDURE_END'", null, null, null, null, null, "';'", "':='", 
        "','", "'['", "']'", "'('", "')'", "':'", "'>'", "'<'", "'='", "'<='", 
        "'>='", "'!='", "'&&'", "'||'", "'+'", "'-'", "'*'", "'.'", "'/'", 
        "'%'", "'!'", "'^'", "'^^'"
    ];

    public static readonly symbolicNames = [
        null, "GT_FORWARD", "GT_BACKWARD", "GT_TURN_RIGHT", "GT_TURN_LEFT", 
        "GT_CLEAR_GRAPHICS", "GT_RESET", "GT_UNDO_DRAWING", "GT_HIDE_TURTLE", 
        "GT_SHOW_TURTLE", "GT_PEN_UP", "GT_PEN_DOWN", "GT_PEN_COLOR", "GT_PEN_THICKNESS", 
        "GT_DRAW_POINT", "GT_MIRROR", "GT_TELEPORT", "GT_COMPASS", "GT_AIM", 
        "GT_MIMIC", "GT_ROTATE_RIGHT", "GT_ROTATE_LEFT", "GT_ROTATE_UP", 
        "GT_ROTATE_DOWN", "GT_ROTATE_XY", "GT_ROTATE_XZ", "GT_ROTATE_YZ", 
        "GT_DRAW_CIRCLE", "GT_DRAW_ARC", "GT_PLAY", "GT_SCORE", "GT_CONCERT", 
        "GT_FILL", "GT_WRITE", "GT_SAY", "GT_INIT", "GT_WAIT", "GT_PAUSE", 
        "GT_STOP", "GT_RETURN", "GT_MANIPULATE_GRAPH", "GT_SNAPSHOT", "GT_EXECUTE", 
        "GT_DELETE", "GT_GLOBAL", "GT_DISPLAY", "GT_WRAP", "GT_WINDOW", 
        "GT_FENCE", "GT_REPEAT", "GT_WHILE", "GT_FOR_EACH", "GT_FROM", "GT_TO", 
        "GT_IN_LIST", "GT_IF", "GT_THEN", "GT_ELSE", "GT_SELECT", "GT_FUNCTION_DEF", 
        "GT_ASK_FOR_VALUE", "GT_PROCEDURE_START", "GT_PROCEDURE_END", "GT_IDENTIFIER", 
        "GT_WORD", "GT_INTEGER_LITERAL", "GT_FLOATING_POINT_LITERAL", "GT_STRING_LITERAL", 
        "GT_STATEMENT_SEPARATOR", "GT_ASSIGN", "GT_COMMA", "GT_LEFT_SQUARE_BRACKET", 
        "GT_RIGHT_SQUARE_BRACKET", "GT_LEFT_PARENTHESIS", "GT_RIGHT_PARENTHESIS", 
        "GT_COLON", "GT_GREATER_THAN", "GT_LESS_THAN", "GT_EQUAL", "GT_LESS_OR_EQUAL", 
        "GT_GREATER_OR_EQUAL", "GT_NOT_EQUAL", "GT_LOGICAL_AND", "GT_LOGICAL_OR", 
        "GT_PLUS", "GT_MINUS", "GT_MULTIPLY", "GT_DOT", "GT_DIVIDE", "GT_MODULO", 
        "GT_LOGICAL_NOT", "GT_POWER", "GT_CROSS_PRODUCT", "GT_NEW_LINE", 
        "GT_HORIZONTAL_WHITESPACE", "GT_LINE_COMMENT_HASH", "GT_LINE_COMMENT_SLASH", 
        "GT_BLOCK_COMMENT"
    ];

    public static readonly modeNames = [
        "DEFAULT_MODE",
    ];

    public static readonly ruleNames = [
        "GT_FORWARD", "GT_BACKWARD", "GT_TURN_RIGHT", "GT_TURN_LEFT", "GT_CLEAR_GRAPHICS", 
        "GT_RESET", "GT_UNDO_DRAWING", "GT_HIDE_TURTLE", "GT_SHOW_TURTLE", 
        "GT_PEN_UP", "GT_PEN_DOWN", "GT_PEN_COLOR", "GT_PEN_THICKNESS", 
        "GT_DRAW_POINT", "GT_MIRROR", "GT_TELEPORT", "GT_COMPASS", "GT_AIM", 
        "GT_MIMIC", "GT_ROTATE_RIGHT", "GT_ROTATE_LEFT", "GT_ROTATE_UP", 
        "GT_ROTATE_DOWN", "GT_ROTATE_XY", "GT_ROTATE_XZ", "GT_ROTATE_YZ", 
        "GT_DRAW_CIRCLE", "GT_DRAW_ARC", "GT_PLAY", "GT_SCORE", "GT_CONCERT", 
        "GT_FILL", "GT_WRITE", "GT_SAY", "GT_INIT", "GT_WAIT", "GT_PAUSE", 
        "GT_STOP", "GT_RETURN", "GT_MANIPULATE_GRAPH", "GT_SNAPSHOT", "GT_EXECUTE", 
        "GT_DELETE", "GT_GLOBAL", "GT_DISPLAY", "GT_WRAP", "GT_WINDOW", 
        "GT_FENCE", "GT_REPEAT", "GT_WHILE", "GT_FOR_EACH", "GT_FROM", "GT_TO", 
        "GT_IN_LIST", "GT_IF", "GT_THEN", "GT_ELSE", "GT_SELECT", "GT_FUNCTION_DEF", 
        "GT_ASK_FOR_VALUE", "GT_PROCEDURE_START", "GT_PROCEDURE_END", "GT_IDENTIFIER", 
        "GT_WORD", "GT_INTEGER_LITERAL", "GT_FLOATING_POINT_LITERAL", "GT_STRING_LITERAL", 
        "GT_STATEMENT_SEPARATOR", "GT_ASSIGN", "GT_COMMA", "GT_LEFT_SQUARE_BRACKET", 
        "GT_RIGHT_SQUARE_BRACKET", "GT_LEFT_PARENTHESIS", "GT_RIGHT_PARENTHESIS", 
        "GT_COLON", "GT_GREATER_THAN", "GT_LESS_THAN", "GT_EQUAL", "GT_LESS_OR_EQUAL", 
        "GT_GREATER_OR_EQUAL", "GT_NOT_EQUAL", "GT_LOGICAL_AND", "GT_LOGICAL_OR", 
        "GT_PLUS", "GT_MINUS", "GT_MULTIPLY", "GT_DOT", "GT_DIVIDE", "GT_MODULO", 
        "GT_LOGICAL_NOT", "GT_POWER", "GT_CROSS_PRODUCT", "GT_DECIMAL_DIGIT", 
        "GT_DECIMAL_DIGITS_FRAGMENT", "GT_EXPONENT_PART_FRAGMENT", "GT_SIMPLE_ID_FRAGMENT", 
        "GT_IDENTIFIER_START_FRAGMENT", "GT_IDENTIFIER_PART_FRAGMENT", "GT_NEW_LINE", 
        "GT_HORIZONTAL_WHITESPACE", "GT_LINE_COMMENT_HASH", "GT_LINE_COMMENT_SLASH", 
        "GT_BLOCK_COMMENT",
    ];


    public constructor(input: antlr.CharStream) {
        super(input);
        this.interpreter = new antlr.LexerATNSimulator(this, GeoTortueLexer._ATN, GeoTortueLexer.decisionsToDFA, new antlr.PredictionContextCache());
    }

    public get grammarFileName(): string { return "GeoTortueLexer.g4"; }

    public get literalNames(): (string | null)[] { return GeoTortueLexer.literalNames; }
    public get symbolicNames(): (string | null)[] { return GeoTortueLexer.symbolicNames; }
    public get ruleNames(): string[] { return GeoTortueLexer.ruleNames; }

    public get serializedATN(): number[] { return GeoTortueLexer._serializedATN; }

    public get channelNames(): string[] { return GeoTortueLexer.channelNames; }

    public get modeNames(): string[] { return GeoTortueLexer.modeNames; }

    public static readonly _serializedATN: number[] = [
        4,0,97,1104,6,-1,2,0,7,0,2,1,7,1,2,2,7,2,2,3,7,3,2,4,7,4,2,5,7,5,
        2,6,7,6,2,7,7,7,2,8,7,8,2,9,7,9,2,10,7,10,2,11,7,11,2,12,7,12,2,
        13,7,13,2,14,7,14,2,15,7,15,2,16,7,16,2,17,7,17,2,18,7,18,2,19,7,
        19,2,20,7,20,2,21,7,21,2,22,7,22,2,23,7,23,2,24,7,24,2,25,7,25,2,
        26,7,26,2,27,7,27,2,28,7,28,2,29,7,29,2,30,7,30,2,31,7,31,2,32,7,
        32,2,33,7,33,2,34,7,34,2,35,7,35,2,36,7,36,2,37,7,37,2,38,7,38,2,
        39,7,39,2,40,7,40,2,41,7,41,2,42,7,42,2,43,7,43,2,44,7,44,2,45,7,
        45,2,46,7,46,2,47,7,47,2,48,7,48,2,49,7,49,2,50,7,50,2,51,7,51,2,
        52,7,52,2,53,7,53,2,54,7,54,2,55,7,55,2,56,7,56,2,57,7,57,2,58,7,
        58,2,59,7,59,2,60,7,60,2,61,7,61,2,62,7,62,2,63,7,63,2,64,7,64,2,
        65,7,65,2,66,7,66,2,67,7,67,2,68,7,68,2,69,7,69,2,70,7,70,2,71,7,
        71,2,72,7,72,2,73,7,73,2,74,7,74,2,75,7,75,2,76,7,76,2,77,7,77,2,
        78,7,78,2,79,7,79,2,80,7,80,2,81,7,81,2,82,7,82,2,83,7,83,2,84,7,
        84,2,85,7,85,2,86,7,86,2,87,7,87,2,88,7,88,2,89,7,89,2,90,7,90,2,
        91,7,91,2,92,7,92,2,93,7,93,2,94,7,94,2,95,7,95,2,96,7,96,2,97,7,
        97,2,98,7,98,2,99,7,99,2,100,7,100,2,101,7,101,2,102,7,102,1,0,1,
        0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,1,1,1,1,1,1,1,1,1,1,1,1,
        1,1,1,1,1,1,1,1,1,1,1,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,
        2,1,2,1,2,1,2,1,3,1,3,1,3,1,3,1,3,1,3,1,3,1,3,1,3,1,3,1,3,1,3,1,
        3,1,4,1,4,1,4,1,4,1,4,1,4,1,4,1,4,1,4,1,4,1,4,1,4,1,4,1,4,1,4,1,
        4,1,4,1,4,1,5,1,5,1,5,1,5,1,5,1,5,1,5,1,5,1,5,1,6,1,6,1,6,1,6,1,
        6,1,6,1,6,1,6,1,6,1,6,1,6,1,6,1,6,1,6,1,6,1,6,1,7,1,7,1,7,1,7,1,
        7,1,7,1,7,1,7,1,7,1,7,1,7,1,7,1,7,1,7,1,7,1,8,1,8,1,8,1,8,1,8,1,
        8,1,8,1,8,1,8,1,8,1,8,1,8,1,8,1,8,1,8,1,9,1,9,1,9,1,9,1,9,1,9,1,
        9,1,9,1,9,1,9,1,10,1,10,1,10,1,10,1,10,1,10,1,10,1,10,1,10,1,10,
        1,10,1,10,1,11,1,11,1,11,1,11,1,11,1,11,1,11,1,11,1,11,1,11,1,11,
        1,11,1,11,1,12,1,12,1,12,1,12,1,12,1,12,1,12,1,12,1,12,1,12,1,12,
        1,12,1,12,1,12,1,12,1,12,1,12,1,13,1,13,1,13,1,13,1,13,1,13,1,13,
        1,13,1,13,1,13,1,13,1,13,1,13,1,13,1,14,1,14,1,14,1,14,1,14,1,14,
        1,14,1,14,1,14,1,14,1,15,1,15,1,15,1,15,1,15,1,15,1,15,1,15,1,15,
        1,15,1,15,1,15,1,16,1,16,1,16,1,16,1,16,1,16,1,16,1,16,1,16,1,16,
        1,16,1,17,1,17,1,17,1,17,1,17,1,17,1,17,1,18,1,18,1,18,1,18,1,18,
        1,18,1,18,1,18,1,18,1,19,1,19,1,19,1,19,1,19,1,19,1,19,1,19,1,19,
        1,19,1,19,1,19,1,19,1,19,1,19,1,19,1,20,1,20,1,20,1,20,1,20,1,20,
        1,20,1,20,1,20,1,20,1,20,1,20,1,20,1,20,1,20,1,21,1,21,1,21,1,21,
        1,21,1,21,1,21,1,21,1,21,1,21,1,21,1,21,1,21,1,22,1,22,1,22,1,22,
        1,22,1,22,1,22,1,22,1,22,1,22,1,22,1,22,1,22,1,22,1,22,1,23,1,23,
        1,23,1,23,1,23,1,23,1,23,1,23,1,23,1,23,1,23,1,23,1,23,1,24,1,24,
        1,24,1,24,1,24,1,24,1,24,1,24,1,24,1,24,1,24,1,24,1,24,1,25,1,25,
        1,25,1,25,1,25,1,25,1,25,1,25,1,25,1,25,1,25,1,25,1,25,1,26,1,26,
        1,26,1,26,1,26,1,26,1,26,1,26,1,26,1,26,1,26,1,26,1,26,1,26,1,26,
        1,27,1,27,1,27,1,27,1,27,1,27,1,27,1,27,1,27,1,27,1,27,1,27,1,28,
        1,28,1,28,1,28,1,28,1,28,1,28,1,28,1,29,1,29,1,29,1,29,1,29,1,29,
        1,29,1,29,1,29,1,30,1,30,1,30,1,30,1,30,1,30,1,30,1,30,1,30,1,30,
        1,30,1,31,1,31,1,31,1,31,1,31,1,31,1,31,1,31,1,32,1,32,1,32,1,32,
        1,32,1,32,1,32,1,32,1,32,1,33,1,33,1,33,1,33,1,33,1,33,1,33,1,34,
        1,34,1,34,1,34,1,34,1,34,1,34,1,34,1,35,1,35,1,35,1,35,1,35,1,35,
        1,35,1,35,1,36,1,36,1,36,1,36,1,36,1,36,1,36,1,36,1,36,1,37,1,37,
        1,37,1,37,1,37,1,37,1,37,1,37,1,38,1,38,1,38,1,38,1,38,1,38,1,38,
        1,38,1,38,1,38,1,39,1,39,1,39,1,39,1,39,1,39,1,39,1,39,1,39,1,39,
        1,39,1,39,1,39,1,39,1,39,1,39,1,39,1,39,1,39,1,39,1,40,1,40,1,40,
        1,40,1,40,1,40,1,40,1,40,1,40,1,40,1,40,1,40,1,41,1,41,1,41,1,41,
        1,41,1,41,1,41,1,41,1,41,1,41,1,41,1,42,1,42,1,42,1,42,1,42,1,42,
        1,42,1,42,1,42,1,42,1,43,1,43,1,43,1,43,1,43,1,43,1,43,1,43,1,43,
        1,43,1,44,1,44,1,44,1,44,1,44,1,44,1,44,1,44,1,44,1,44,1,44,1,45,
        1,45,1,45,1,45,1,45,1,45,1,45,1,45,1,46,1,46,1,46,1,46,1,46,1,46,
        1,46,1,46,1,46,1,46,1,47,1,47,1,47,1,47,1,47,1,47,1,47,1,47,1,47,
        1,48,1,48,1,48,1,48,1,48,1,48,1,48,1,48,1,48,1,48,1,49,1,49,1,49,
        1,49,1,49,1,49,1,49,1,49,1,49,1,50,1,50,1,50,1,50,1,50,1,50,1,50,
        1,50,1,50,1,50,1,50,1,50,1,51,1,51,1,51,1,51,1,51,1,51,1,51,1,51,
        1,52,1,52,1,52,1,52,1,52,1,52,1,53,1,53,1,53,1,53,1,53,1,53,1,53,
        1,53,1,53,1,53,1,53,1,54,1,54,1,54,1,54,1,54,1,54,1,55,1,55,1,55,
        1,55,1,55,1,55,1,55,1,55,1,56,1,56,1,56,1,56,1,56,1,56,1,56,1,56,
        1,57,1,57,1,57,1,57,1,57,1,57,1,57,1,57,1,57,1,57,1,58,1,58,1,58,
        1,58,1,58,1,58,1,58,1,58,1,58,1,58,1,58,1,58,1,58,1,58,1,58,1,58,
        1,59,1,59,1,59,1,59,1,59,1,59,1,59,1,59,1,59,1,59,1,59,1,59,1,59,
        1,59,1,59,1,59,1,59,1,60,1,60,1,60,1,60,1,60,1,60,1,60,1,60,1,60,
        1,60,1,60,1,60,1,60,1,60,1,60,1,60,1,60,1,60,1,60,1,61,1,61,1,61,
        1,61,1,61,1,61,1,61,1,61,1,61,1,61,1,61,1,61,1,61,1,61,1,61,1,61,
        1,61,1,62,1,62,1,62,5,62,927,8,62,10,62,12,62,930,9,62,1,63,1,63,
        1,63,5,63,935,8,63,10,63,12,63,938,9,63,1,64,1,64,1,65,1,65,1,65,
        3,65,945,8,65,1,65,3,65,948,8,65,1,65,1,65,1,65,3,65,953,8,65,1,
        65,1,65,1,65,3,65,958,8,65,1,66,1,66,1,66,1,66,5,66,964,8,66,10,
        66,12,66,967,9,66,1,66,1,66,1,67,1,67,1,68,1,68,1,68,1,69,1,69,1,
        70,1,70,1,71,1,71,1,72,1,72,1,73,1,73,1,74,1,74,1,75,1,75,1,76,1,
        76,1,77,1,77,1,78,1,78,1,78,1,79,1,79,1,79,1,80,1,80,1,80,1,81,1,
        81,1,81,1,82,1,82,1,82,1,83,1,83,1,84,1,84,1,85,1,85,1,86,1,86,1,
        87,1,87,1,88,1,88,1,89,1,89,1,90,1,90,1,91,1,91,1,91,1,92,1,92,1,
        93,4,93,1031,8,93,11,93,12,93,1032,1,94,1,94,3,94,1037,8,94,1,94,
        4,94,1040,8,94,11,94,12,94,1041,1,95,3,95,1045,8,95,1,96,1,96,1,
        96,3,96,1050,8,96,1,97,1,97,3,97,1054,8,97,1,98,3,98,1057,8,98,1,
        98,4,98,1060,8,98,11,98,12,98,1061,1,99,4,99,1065,8,99,11,99,12,
        99,1066,1,99,1,99,1,100,1,100,5,100,1073,8,100,10,100,12,100,1076,
        9,100,1,100,1,100,1,101,1,101,1,101,1,101,5,101,1084,8,101,10,101,
        12,101,1087,9,101,1,101,1,101,1,102,1,102,1,102,1,102,5,102,1095,
        8,102,10,102,12,102,1098,9,102,1,102,1,102,1,102,1,102,1,102,1,1096,
        0,103,1,1,3,2,5,3,7,4,9,5,11,6,13,7,15,8,17,9,19,10,21,11,23,12,
        25,13,27,14,29,15,31,16,33,17,35,18,37,19,39,20,41,21,43,22,45,23,
        47,24,49,25,51,26,53,27,55,28,57,29,59,30,61,31,63,32,65,33,67,34,
        69,35,71,36,73,37,75,38,77,39,79,40,81,41,83,42,85,43,87,44,89,45,
        91,46,93,47,95,48,97,49,99,50,101,51,103,52,105,53,107,54,109,55,
        111,56,113,57,115,58,117,59,119,60,121,61,123,62,125,63,127,64,129,
        65,131,66,133,67,135,68,137,69,139,70,141,71,143,72,145,73,147,74,
        149,75,151,76,153,77,155,78,157,79,159,80,161,81,163,82,165,83,167,
        84,169,85,171,86,173,87,175,88,177,89,179,90,181,91,183,92,185,0,
        187,0,189,0,191,0,193,0,195,0,197,93,199,94,201,95,203,96,205,97,
        1,0,9,4,0,10,10,13,13,34,34,92,92,8,0,34,34,39,39,92,92,98,98,102,
        102,110,110,114,114,116,116,1,0,48,57,2,0,69,69,101,101,2,0,43,43,
        45,45,3,0,65,90,95,95,97,122,8,0,192,214,216,246,248,8191,12352,
        12687,13056,13183,13312,15661,19968,40959,63744,64255,3,0,9,9,12,
        12,32,32,2,0,10,10,13,13,1120,0,1,1,0,0,0,0,3,1,0,0,0,0,5,1,0,0,
        0,0,7,1,0,0,0,0,9,1,0,0,0,0,11,1,0,0,0,0,13,1,0,0,0,0,15,1,0,0,0,
        0,17,1,0,0,0,0,19,1,0,0,0,0,21,1,0,0,0,0,23,1,0,0,0,0,25,1,0,0,0,
        0,27,1,0,0,0,0,29,1,0,0,0,0,31,1,0,0,0,0,33,1,0,0,0,0,35,1,0,0,0,
        0,37,1,0,0,0,0,39,1,0,0,0,0,41,1,0,0,0,0,43,1,0,0,0,0,45,1,0,0,0,
        0,47,1,0,0,0,0,49,1,0,0,0,0,51,1,0,0,0,0,53,1,0,0,0,0,55,1,0,0,0,
        0,57,1,0,0,0,0,59,1,0,0,0,0,61,1,0,0,0,0,63,1,0,0,0,0,65,1,0,0,0,
        0,67,1,0,0,0,0,69,1,0,0,0,0,71,1,0,0,0,0,73,1,0,0,0,0,75,1,0,0,0,
        0,77,1,0,0,0,0,79,1,0,0,0,0,81,1,0,0,0,0,83,1,0,0,0,0,85,1,0,0,0,
        0,87,1,0,0,0,0,89,1,0,0,0,0,91,1,0,0,0,0,93,1,0,0,0,0,95,1,0,0,0,
        0,97,1,0,0,0,0,99,1,0,0,0,0,101,1,0,0,0,0,103,1,0,0,0,0,105,1,0,
        0,0,0,107,1,0,0,0,0,109,1,0,0,0,0,111,1,0,0,0,0,113,1,0,0,0,0,115,
        1,0,0,0,0,117,1,0,0,0,0,119,1,0,0,0,0,121,1,0,0,0,0,123,1,0,0,0,
        0,125,1,0,0,0,0,127,1,0,0,0,0,129,1,0,0,0,0,131,1,0,0,0,0,133,1,
        0,0,0,0,135,1,0,0,0,0,137,1,0,0,0,0,139,1,0,0,0,0,141,1,0,0,0,0,
        143,1,0,0,0,0,145,1,0,0,0,0,147,1,0,0,0,0,149,1,0,0,0,0,151,1,0,
        0,0,0,153,1,0,0,0,0,155,1,0,0,0,0,157,1,0,0,0,0,159,1,0,0,0,0,161,
        1,0,0,0,0,163,1,0,0,0,0,165,1,0,0,0,0,167,1,0,0,0,0,169,1,0,0,0,
        0,171,1,0,0,0,0,173,1,0,0,0,0,175,1,0,0,0,0,177,1,0,0,0,0,179,1,
        0,0,0,0,181,1,0,0,0,0,183,1,0,0,0,0,197,1,0,0,0,0,199,1,0,0,0,0,
        201,1,0,0,0,0,203,1,0,0,0,0,205,1,0,0,0,1,207,1,0,0,0,3,218,1,0,
        0,0,5,230,1,0,0,0,7,244,1,0,0,0,9,257,1,0,0,0,11,275,1,0,0,0,13,
        284,1,0,0,0,15,300,1,0,0,0,17,315,1,0,0,0,19,330,1,0,0,0,21,340,
        1,0,0,0,23,352,1,0,0,0,25,365,1,0,0,0,27,382,1,0,0,0,29,396,1,0,
        0,0,31,406,1,0,0,0,33,418,1,0,0,0,35,429,1,0,0,0,37,436,1,0,0,0,
        39,445,1,0,0,0,41,461,1,0,0,0,43,476,1,0,0,0,45,489,1,0,0,0,47,504,
        1,0,0,0,49,517,1,0,0,0,51,530,1,0,0,0,53,543,1,0,0,0,55,558,1,0,
        0,0,57,570,1,0,0,0,59,578,1,0,0,0,61,587,1,0,0,0,63,598,1,0,0,0,
        65,606,1,0,0,0,67,615,1,0,0,0,69,622,1,0,0,0,71,630,1,0,0,0,73,638,
        1,0,0,0,75,647,1,0,0,0,77,655,1,0,0,0,79,665,1,0,0,0,81,685,1,0,
        0,0,83,697,1,0,0,0,85,708,1,0,0,0,87,718,1,0,0,0,89,728,1,0,0,0,
        91,739,1,0,0,0,93,747,1,0,0,0,95,757,1,0,0,0,97,766,1,0,0,0,99,776,
        1,0,0,0,101,785,1,0,0,0,103,797,1,0,0,0,105,805,1,0,0,0,107,811,
        1,0,0,0,109,822,1,0,0,0,111,828,1,0,0,0,113,836,1,0,0,0,115,844,
        1,0,0,0,117,854,1,0,0,0,119,870,1,0,0,0,121,887,1,0,0,0,123,906,
        1,0,0,0,125,923,1,0,0,0,127,931,1,0,0,0,129,939,1,0,0,0,131,957,
        1,0,0,0,133,959,1,0,0,0,135,970,1,0,0,0,137,972,1,0,0,0,139,975,
        1,0,0,0,141,977,1,0,0,0,143,979,1,0,0,0,145,981,1,0,0,0,147,983,
        1,0,0,0,149,985,1,0,0,0,151,987,1,0,0,0,153,989,1,0,0,0,155,991,
        1,0,0,0,157,993,1,0,0,0,159,996,1,0,0,0,161,999,1,0,0,0,163,1002,
        1,0,0,0,165,1005,1,0,0,0,167,1008,1,0,0,0,169,1010,1,0,0,0,171,1012,
        1,0,0,0,173,1014,1,0,0,0,175,1016,1,0,0,0,177,1018,1,0,0,0,179,1020,
        1,0,0,0,181,1022,1,0,0,0,183,1024,1,0,0,0,185,1027,1,0,0,0,187,1030,
        1,0,0,0,189,1034,1,0,0,0,191,1044,1,0,0,0,193,1049,1,0,0,0,195,1053,
        1,0,0,0,197,1059,1,0,0,0,199,1064,1,0,0,0,201,1070,1,0,0,0,203,1079,
        1,0,0,0,205,1090,1,0,0,0,207,208,5,71,0,0,208,209,5,84,0,0,209,210,
        5,95,0,0,210,211,5,70,0,0,211,212,5,79,0,0,212,213,5,82,0,0,213,
        214,5,87,0,0,214,215,5,65,0,0,215,216,5,82,0,0,216,217,5,68,0,0,
        217,2,1,0,0,0,218,219,5,71,0,0,219,220,5,84,0,0,220,221,5,95,0,0,
        221,222,5,66,0,0,222,223,5,65,0,0,223,224,5,67,0,0,224,225,5,75,
        0,0,225,226,5,87,0,0,226,227,5,65,0,0,227,228,5,82,0,0,228,229,5,
        68,0,0,229,4,1,0,0,0,230,231,5,71,0,0,231,232,5,84,0,0,232,233,5,
        95,0,0,233,234,5,84,0,0,234,235,5,85,0,0,235,236,5,82,0,0,236,237,
        5,78,0,0,237,238,5,95,0,0,238,239,5,82,0,0,239,240,5,73,0,0,240,
        241,5,71,0,0,241,242,5,72,0,0,242,243,5,84,0,0,243,6,1,0,0,0,244,
        245,5,71,0,0,245,246,5,84,0,0,246,247,5,95,0,0,247,248,5,84,0,0,
        248,249,5,85,0,0,249,250,5,82,0,0,250,251,5,78,0,0,251,252,5,95,
        0,0,252,253,5,76,0,0,253,254,5,69,0,0,254,255,5,70,0,0,255,256,5,
        84,0,0,256,8,1,0,0,0,257,258,5,71,0,0,258,259,5,84,0,0,259,260,5,
        95,0,0,260,261,5,67,0,0,261,262,5,76,0,0,262,263,5,69,0,0,263,264,
        5,65,0,0,264,265,5,82,0,0,265,266,5,95,0,0,266,267,5,71,0,0,267,
        268,5,82,0,0,268,269,5,65,0,0,269,270,5,80,0,0,270,271,5,72,0,0,
        271,272,5,73,0,0,272,273,5,67,0,0,273,274,5,83,0,0,274,10,1,0,0,
        0,275,276,5,71,0,0,276,277,5,84,0,0,277,278,5,95,0,0,278,279,5,82,
        0,0,279,280,5,69,0,0,280,281,5,83,0,0,281,282,5,69,0,0,282,283,5,
        84,0,0,283,12,1,0,0,0,284,285,5,71,0,0,285,286,5,84,0,0,286,287,
        5,95,0,0,287,288,5,85,0,0,288,289,5,78,0,0,289,290,5,68,0,0,290,
        291,5,79,0,0,291,292,5,95,0,0,292,293,5,68,0,0,293,294,5,82,0,0,
        294,295,5,65,0,0,295,296,5,87,0,0,296,297,5,73,0,0,297,298,5,78,
        0,0,298,299,5,71,0,0,299,14,1,0,0,0,300,301,5,71,0,0,301,302,5,84,
        0,0,302,303,5,95,0,0,303,304,5,72,0,0,304,305,5,73,0,0,305,306,5,
        68,0,0,306,307,5,69,0,0,307,308,5,95,0,0,308,309,5,84,0,0,309,310,
        5,85,0,0,310,311,5,82,0,0,311,312,5,84,0,0,312,313,5,76,0,0,313,
        314,5,69,0,0,314,16,1,0,0,0,315,316,5,71,0,0,316,317,5,84,0,0,317,
        318,5,95,0,0,318,319,5,83,0,0,319,320,5,72,0,0,320,321,5,79,0,0,
        321,322,5,87,0,0,322,323,5,95,0,0,323,324,5,84,0,0,324,325,5,85,
        0,0,325,326,5,82,0,0,326,327,5,84,0,0,327,328,5,76,0,0,328,329,5,
        69,0,0,329,18,1,0,0,0,330,331,5,71,0,0,331,332,5,84,0,0,332,333,
        5,95,0,0,333,334,5,80,0,0,334,335,5,69,0,0,335,336,5,78,0,0,336,
        337,5,95,0,0,337,338,5,85,0,0,338,339,5,80,0,0,339,20,1,0,0,0,340,
        341,5,71,0,0,341,342,5,84,0,0,342,343,5,95,0,0,343,344,5,80,0,0,
        344,345,5,69,0,0,345,346,5,78,0,0,346,347,5,95,0,0,347,348,5,68,
        0,0,348,349,5,79,0,0,349,350,5,87,0,0,350,351,5,78,0,0,351,22,1,
        0,0,0,352,353,5,71,0,0,353,354,5,84,0,0,354,355,5,95,0,0,355,356,
        5,80,0,0,356,357,5,69,0,0,357,358,5,78,0,0,358,359,5,95,0,0,359,
        360,5,67,0,0,360,361,5,79,0,0,361,362,5,76,0,0,362,363,5,79,0,0,
        363,364,5,82,0,0,364,24,1,0,0,0,365,366,5,71,0,0,366,367,5,84,0,
        0,367,368,5,95,0,0,368,369,5,80,0,0,369,370,5,69,0,0,370,371,5,78,
        0,0,371,372,5,95,0,0,372,373,5,84,0,0,373,374,5,72,0,0,374,375,5,
        73,0,0,375,376,5,67,0,0,376,377,5,75,0,0,377,378,5,78,0,0,378,379,
        5,69,0,0,379,380,5,83,0,0,380,381,5,83,0,0,381,26,1,0,0,0,382,383,
        5,71,0,0,383,384,5,84,0,0,384,385,5,95,0,0,385,386,5,68,0,0,386,
        387,5,82,0,0,387,388,5,65,0,0,388,389,5,87,0,0,389,390,5,95,0,0,
        390,391,5,80,0,0,391,392,5,79,0,0,392,393,5,73,0,0,393,394,5,78,
        0,0,394,395,5,84,0,0,395,28,1,0,0,0,396,397,5,71,0,0,397,398,5,84,
        0,0,398,399,5,95,0,0,399,400,5,77,0,0,400,401,5,73,0,0,401,402,5,
        82,0,0,402,403,5,82,0,0,403,404,5,79,0,0,404,405,5,82,0,0,405,30,
        1,0,0,0,406,407,5,71,0,0,407,408,5,84,0,0,408,409,5,95,0,0,409,410,
        5,84,0,0,410,411,5,69,0,0,411,412,5,76,0,0,412,413,5,69,0,0,413,
        414,5,80,0,0,414,415,5,79,0,0,415,416,5,82,0,0,416,417,5,84,0,0,
        417,32,1,0,0,0,418,419,5,71,0,0,419,420,5,84,0,0,420,421,5,95,0,
        0,421,422,5,67,0,0,422,423,5,79,0,0,423,424,5,77,0,0,424,425,5,80,
        0,0,425,426,5,65,0,0,426,427,5,83,0,0,427,428,5,83,0,0,428,34,1,
        0,0,0,429,430,5,71,0,0,430,431,5,84,0,0,431,432,5,95,0,0,432,433,
        5,65,0,0,433,434,5,73,0,0,434,435,5,77,0,0,435,36,1,0,0,0,436,437,
        5,71,0,0,437,438,5,84,0,0,438,439,5,95,0,0,439,440,5,77,0,0,440,
        441,5,73,0,0,441,442,5,77,0,0,442,443,5,73,0,0,443,444,5,67,0,0,
        444,38,1,0,0,0,445,446,5,71,0,0,446,447,5,84,0,0,447,448,5,95,0,
        0,448,449,5,82,0,0,449,450,5,79,0,0,450,451,5,84,0,0,451,452,5,65,
        0,0,452,453,5,84,0,0,453,454,5,69,0,0,454,455,5,95,0,0,455,456,5,
        82,0,0,456,457,5,73,0,0,457,458,5,71,0,0,458,459,5,72,0,0,459,460,
        5,84,0,0,460,40,1,0,0,0,461,462,5,71,0,0,462,463,5,84,0,0,463,464,
        5,95,0,0,464,465,5,82,0,0,465,466,5,79,0,0,466,467,5,84,0,0,467,
        468,5,65,0,0,468,469,5,84,0,0,469,470,5,69,0,0,470,471,5,95,0,0,
        471,472,5,76,0,0,472,473,5,69,0,0,473,474,5,70,0,0,474,475,5,84,
        0,0,475,42,1,0,0,0,476,477,5,71,0,0,477,478,5,84,0,0,478,479,5,95,
        0,0,479,480,5,82,0,0,480,481,5,79,0,0,481,482,5,84,0,0,482,483,5,
        65,0,0,483,484,5,84,0,0,484,485,5,69,0,0,485,486,5,95,0,0,486,487,
        5,85,0,0,487,488,5,80,0,0,488,44,1,0,0,0,489,490,5,71,0,0,490,491,
        5,84,0,0,491,492,5,95,0,0,492,493,5,82,0,0,493,494,5,79,0,0,494,
        495,5,84,0,0,495,496,5,65,0,0,496,497,5,84,0,0,497,498,5,69,0,0,
        498,499,5,95,0,0,499,500,5,68,0,0,500,501,5,79,0,0,501,502,5,87,
        0,0,502,503,5,78,0,0,503,46,1,0,0,0,504,505,5,71,0,0,505,506,5,84,
        0,0,506,507,5,95,0,0,507,508,5,82,0,0,508,509,5,79,0,0,509,510,5,
        84,0,0,510,511,5,65,0,0,511,512,5,84,0,0,512,513,5,69,0,0,513,514,
        5,95,0,0,514,515,5,88,0,0,515,516,5,89,0,0,516,48,1,0,0,0,517,518,
        5,71,0,0,518,519,5,84,0,0,519,520,5,95,0,0,520,521,5,82,0,0,521,
        522,5,79,0,0,522,523,5,84,0,0,523,524,5,65,0,0,524,525,5,84,0,0,
        525,526,5,69,0,0,526,527,5,95,0,0,527,528,5,88,0,0,528,529,5,90,
        0,0,529,50,1,0,0,0,530,531,5,71,0,0,531,532,5,84,0,0,532,533,5,95,
        0,0,533,534,5,82,0,0,534,535,5,79,0,0,535,536,5,84,0,0,536,537,5,
        65,0,0,537,538,5,84,0,0,538,539,5,69,0,0,539,540,5,95,0,0,540,541,
        5,89,0,0,541,542,5,90,0,0,542,52,1,0,0,0,543,544,5,71,0,0,544,545,
        5,84,0,0,545,546,5,95,0,0,546,547,5,68,0,0,547,548,5,82,0,0,548,
        549,5,65,0,0,549,550,5,87,0,0,550,551,5,95,0,0,551,552,5,67,0,0,
        552,553,5,73,0,0,553,554,5,82,0,0,554,555,5,67,0,0,555,556,5,76,
        0,0,556,557,5,69,0,0,557,54,1,0,0,0,558,559,5,71,0,0,559,560,5,84,
        0,0,560,561,5,95,0,0,561,562,5,68,0,0,562,563,5,82,0,0,563,564,5,
        65,0,0,564,565,5,87,0,0,565,566,5,95,0,0,566,567,5,65,0,0,567,568,
        5,82,0,0,568,569,5,67,0,0,569,56,1,0,0,0,570,571,5,71,0,0,571,572,
        5,84,0,0,572,573,5,95,0,0,573,574,5,80,0,0,574,575,5,76,0,0,575,
        576,5,65,0,0,576,577,5,89,0,0,577,58,1,0,0,0,578,579,5,71,0,0,579,
        580,5,84,0,0,580,581,5,95,0,0,581,582,5,83,0,0,582,583,5,67,0,0,
        583,584,5,79,0,0,584,585,5,82,0,0,585,586,5,69,0,0,586,60,1,0,0,
        0,587,588,5,71,0,0,588,589,5,84,0,0,589,590,5,95,0,0,590,591,5,67,
        0,0,591,592,5,79,0,0,592,593,5,78,0,0,593,594,5,67,0,0,594,595,5,
        69,0,0,595,596,5,82,0,0,596,597,5,84,0,0,597,62,1,0,0,0,598,599,
        5,71,0,0,599,600,5,84,0,0,600,601,5,95,0,0,601,602,5,70,0,0,602,
        603,5,73,0,0,603,604,5,76,0,0,604,605,5,76,0,0,605,64,1,0,0,0,606,
        607,5,71,0,0,607,608,5,84,0,0,608,609,5,95,0,0,609,610,5,87,0,0,
        610,611,5,82,0,0,611,612,5,73,0,0,612,613,5,84,0,0,613,614,5,69,
        0,0,614,66,1,0,0,0,615,616,5,71,0,0,616,617,5,84,0,0,617,618,5,95,
        0,0,618,619,5,83,0,0,619,620,5,65,0,0,620,621,5,89,0,0,621,68,1,
        0,0,0,622,623,5,71,0,0,623,624,5,84,0,0,624,625,5,95,0,0,625,626,
        5,73,0,0,626,627,5,78,0,0,627,628,5,73,0,0,628,629,5,84,0,0,629,
        70,1,0,0,0,630,631,5,71,0,0,631,632,5,84,0,0,632,633,5,95,0,0,633,
        634,5,87,0,0,634,635,5,65,0,0,635,636,5,73,0,0,636,637,5,84,0,0,
        637,72,1,0,0,0,638,639,5,71,0,0,639,640,5,84,0,0,640,641,5,95,0,
        0,641,642,5,80,0,0,642,643,5,65,0,0,643,644,5,85,0,0,644,645,5,83,
        0,0,645,646,5,69,0,0,646,74,1,0,0,0,647,648,5,71,0,0,648,649,5,84,
        0,0,649,650,5,95,0,0,650,651,5,83,0,0,651,652,5,84,0,0,652,653,5,
        79,0,0,653,654,5,80,0,0,654,76,1,0,0,0,655,656,5,71,0,0,656,657,
        5,84,0,0,657,658,5,95,0,0,658,659,5,82,0,0,659,660,5,69,0,0,660,
        661,5,84,0,0,661,662,5,85,0,0,662,663,5,82,0,0,663,664,5,78,0,0,
        664,78,1,0,0,0,665,666,5,71,0,0,666,667,5,84,0,0,667,668,5,95,0,
        0,668,669,5,77,0,0,669,670,5,65,0,0,670,671,5,78,0,0,671,672,5,73,
        0,0,672,673,5,80,0,0,673,674,5,85,0,0,674,675,5,76,0,0,675,676,5,
        65,0,0,676,677,5,84,0,0,677,678,5,69,0,0,678,679,5,95,0,0,679,680,
        5,71,0,0,680,681,5,82,0,0,681,682,5,65,0,0,682,683,5,80,0,0,683,
        684,5,72,0,0,684,80,1,0,0,0,685,686,5,71,0,0,686,687,5,84,0,0,687,
        688,5,95,0,0,688,689,5,83,0,0,689,690,5,78,0,0,690,691,5,65,0,0,
        691,692,5,80,0,0,692,693,5,83,0,0,693,694,5,72,0,0,694,695,5,79,
        0,0,695,696,5,84,0,0,696,82,1,0,0,0,697,698,5,71,0,0,698,699,5,84,
        0,0,699,700,5,95,0,0,700,701,5,69,0,0,701,702,5,88,0,0,702,703,5,
        69,0,0,703,704,5,67,0,0,704,705,5,85,0,0,705,706,5,84,0,0,706,707,
        5,69,0,0,707,84,1,0,0,0,708,709,5,71,0,0,709,710,5,84,0,0,710,711,
        5,95,0,0,711,712,5,68,0,0,712,713,5,69,0,0,713,714,5,76,0,0,714,
        715,5,69,0,0,715,716,5,84,0,0,716,717,5,69,0,0,717,86,1,0,0,0,718,
        719,5,71,0,0,719,720,5,84,0,0,720,721,5,95,0,0,721,722,5,71,0,0,
        722,723,5,76,0,0,723,724,5,79,0,0,724,725,5,66,0,0,725,726,5,65,
        0,0,726,727,5,76,0,0,727,88,1,0,0,0,728,729,5,71,0,0,729,730,5,84,
        0,0,730,731,5,95,0,0,731,732,5,68,0,0,732,733,5,73,0,0,733,734,5,
        83,0,0,734,735,5,80,0,0,735,736,5,76,0,0,736,737,5,65,0,0,737,738,
        5,89,0,0,738,90,1,0,0,0,739,740,5,71,0,0,740,741,5,84,0,0,741,742,
        5,95,0,0,742,743,5,87,0,0,743,744,5,82,0,0,744,745,5,65,0,0,745,
        746,5,80,0,0,746,92,1,0,0,0,747,748,5,71,0,0,748,749,5,84,0,0,749,
        750,5,95,0,0,750,751,5,87,0,0,751,752,5,73,0,0,752,753,5,78,0,0,
        753,754,5,68,0,0,754,755,5,79,0,0,755,756,5,87,0,0,756,94,1,0,0,
        0,757,758,5,71,0,0,758,759,5,84,0,0,759,760,5,95,0,0,760,761,5,70,
        0,0,761,762,5,69,0,0,762,763,5,78,0,0,763,764,5,67,0,0,764,765,5,
        69,0,0,765,96,1,0,0,0,766,767,5,71,0,0,767,768,5,84,0,0,768,769,
        5,95,0,0,769,770,5,82,0,0,770,771,5,69,0,0,771,772,5,80,0,0,772,
        773,5,69,0,0,773,774,5,65,0,0,774,775,5,84,0,0,775,98,1,0,0,0,776,
        777,5,71,0,0,777,778,5,84,0,0,778,779,5,95,0,0,779,780,5,87,0,0,
        780,781,5,72,0,0,781,782,5,73,0,0,782,783,5,76,0,0,783,784,5,69,
        0,0,784,100,1,0,0,0,785,786,5,71,0,0,786,787,5,84,0,0,787,788,5,
        95,0,0,788,789,5,70,0,0,789,790,5,79,0,0,790,791,5,82,0,0,791,792,
        5,95,0,0,792,793,5,69,0,0,793,794,5,65,0,0,794,795,5,67,0,0,795,
        796,5,72,0,0,796,102,1,0,0,0,797,798,5,71,0,0,798,799,5,84,0,0,799,
        800,5,95,0,0,800,801,5,70,0,0,801,802,5,82,0,0,802,803,5,79,0,0,
        803,804,5,77,0,0,804,104,1,0,0,0,805,806,5,71,0,0,806,807,5,84,0,
        0,807,808,5,95,0,0,808,809,5,84,0,0,809,810,5,79,0,0,810,106,1,0,
        0,0,811,812,5,71,0,0,812,813,5,84,0,0,813,814,5,95,0,0,814,815,5,
        73,0,0,815,816,5,78,0,0,816,817,5,95,0,0,817,818,5,76,0,0,818,819,
        5,73,0,0,819,820,5,83,0,0,820,821,5,84,0,0,821,108,1,0,0,0,822,823,
        5,71,0,0,823,824,5,84,0,0,824,825,5,95,0,0,825,826,5,73,0,0,826,
        827,5,70,0,0,827,110,1,0,0,0,828,829,5,71,0,0,829,830,5,84,0,0,830,
        831,5,95,0,0,831,832,5,84,0,0,832,833,5,72,0,0,833,834,5,69,0,0,
        834,835,5,78,0,0,835,112,1,0,0,0,836,837,5,71,0,0,837,838,5,84,0,
        0,838,839,5,95,0,0,839,840,5,69,0,0,840,841,5,76,0,0,841,842,5,83,
        0,0,842,843,5,69,0,0,843,114,1,0,0,0,844,845,5,71,0,0,845,846,5,
        84,0,0,846,847,5,95,0,0,847,848,5,83,0,0,848,849,5,69,0,0,849,850,
        5,76,0,0,850,851,5,69,0,0,851,852,5,67,0,0,852,853,5,84,0,0,853,
        116,1,0,0,0,854,855,5,71,0,0,855,856,5,84,0,0,856,857,5,95,0,0,857,
        858,5,70,0,0,858,859,5,85,0,0,859,860,5,78,0,0,860,861,5,67,0,0,
        861,862,5,84,0,0,862,863,5,73,0,0,863,864,5,79,0,0,864,865,5,78,
        0,0,865,866,5,95,0,0,866,867,5,68,0,0,867,868,5,69,0,0,868,869,5,
        70,0,0,869,118,1,0,0,0,870,871,5,71,0,0,871,872,5,84,0,0,872,873,
        5,95,0,0,873,874,5,65,0,0,874,875,5,83,0,0,875,876,5,75,0,0,876,
        877,5,95,0,0,877,878,5,70,0,0,878,879,5,79,0,0,879,880,5,82,0,0,
        880,881,5,95,0,0,881,882,5,86,0,0,882,883,5,65,0,0,883,884,5,76,
        0,0,884,885,5,85,0,0,885,886,5,69,0,0,886,120,1,0,0,0,887,888,5,
        71,0,0,888,889,5,84,0,0,889,890,5,95,0,0,890,891,5,80,0,0,891,892,
        5,82,0,0,892,893,5,79,0,0,893,894,5,67,0,0,894,895,5,69,0,0,895,
        896,5,68,0,0,896,897,5,85,0,0,897,898,5,82,0,0,898,899,5,69,0,0,
        899,900,5,95,0,0,900,901,5,83,0,0,901,902,5,84,0,0,902,903,5,65,
        0,0,903,904,5,82,0,0,904,905,5,84,0,0,905,122,1,0,0,0,906,907,5,
        71,0,0,907,908,5,84,0,0,908,909,5,95,0,0,909,910,5,80,0,0,910,911,
        5,82,0,0,911,912,5,79,0,0,912,913,5,67,0,0,913,914,5,69,0,0,914,
        915,5,68,0,0,915,916,5,85,0,0,916,917,5,82,0,0,917,918,5,69,0,0,
        918,919,5,95,0,0,919,920,5,69,0,0,920,921,5,78,0,0,921,922,5,68,
        0,0,922,124,1,0,0,0,923,928,3,191,95,0,924,927,3,191,95,0,925,927,
        3,185,92,0,926,924,1,0,0,0,926,925,1,0,0,0,927,930,1,0,0,0,928,926,
        1,0,0,0,928,929,1,0,0,0,929,126,1,0,0,0,930,928,1,0,0,0,931,936,
        3,193,96,0,932,935,3,195,97,0,933,935,5,46,0,0,934,932,1,0,0,0,934,
        933,1,0,0,0,935,938,1,0,0,0,936,934,1,0,0,0,936,937,1,0,0,0,937,
        128,1,0,0,0,938,936,1,0,0,0,939,940,3,187,93,0,940,130,1,0,0,0,941,
        942,3,187,93,0,942,944,5,46,0,0,943,945,3,187,93,0,944,943,1,0,0,
        0,944,945,1,0,0,0,945,947,1,0,0,0,946,948,3,189,94,0,947,946,1,0,
        0,0,947,948,1,0,0,0,948,958,1,0,0,0,949,950,5,46,0,0,950,952,3,187,
        93,0,951,953,3,189,94,0,952,951,1,0,0,0,952,953,1,0,0,0,953,958,
        1,0,0,0,954,955,3,187,93,0,955,956,3,189,94,0,956,958,1,0,0,0,957,
        941,1,0,0,0,957,949,1,0,0,0,957,954,1,0,0,0,958,132,1,0,0,0,959,
        965,5,34,0,0,960,964,8,0,0,0,961,962,5,92,0,0,962,964,7,1,0,0,963,
        960,1,0,0,0,963,961,1,0,0,0,964,967,1,0,0,0,965,963,1,0,0,0,965,
        966,1,0,0,0,966,968,1,0,0,0,967,965,1,0,0,0,968,969,5,34,0,0,969,
        134,1,0,0,0,970,971,5,59,0,0,971,136,1,0,0,0,972,973,5,58,0,0,973,
        974,5,61,0,0,974,138,1,0,0,0,975,976,5,44,0,0,976,140,1,0,0,0,977,
        978,5,91,0,0,978,142,1,0,0,0,979,980,5,93,0,0,980,144,1,0,0,0,981,
        982,5,40,0,0,982,146,1,0,0,0,983,984,5,41,0,0,984,148,1,0,0,0,985,
        986,5,58,0,0,986,150,1,0,0,0,987,988,5,62,0,0,988,152,1,0,0,0,989,
        990,5,60,0,0,990,154,1,0,0,0,991,992,5,61,0,0,992,156,1,0,0,0,993,
        994,5,60,0,0,994,995,5,61,0,0,995,158,1,0,0,0,996,997,5,62,0,0,997,
        998,5,61,0,0,998,160,1,0,0,0,999,1000,5,33,0,0,1000,1001,5,61,0,
        0,1001,162,1,0,0,0,1002,1003,5,38,0,0,1003,1004,5,38,0,0,1004,164,
        1,0,0,0,1005,1006,5,124,0,0,1006,1007,5,124,0,0,1007,166,1,0,0,0,
        1008,1009,5,43,0,0,1009,168,1,0,0,0,1010,1011,5,45,0,0,1011,170,
        1,0,0,0,1012,1013,5,42,0,0,1013,172,1,0,0,0,1014,1015,5,46,0,0,1015,
        174,1,0,0,0,1016,1017,5,47,0,0,1017,176,1,0,0,0,1018,1019,5,37,0,
        0,1019,178,1,0,0,0,1020,1021,5,33,0,0,1021,180,1,0,0,0,1022,1023,
        5,94,0,0,1023,182,1,0,0,0,1024,1025,5,94,0,0,1025,1026,5,94,0,0,
        1026,184,1,0,0,0,1027,1028,7,2,0,0,1028,186,1,0,0,0,1029,1031,7,
        2,0,0,1030,1029,1,0,0,0,1031,1032,1,0,0,0,1032,1030,1,0,0,0,1032,
        1033,1,0,0,0,1033,188,1,0,0,0,1034,1036,7,3,0,0,1035,1037,7,4,0,
        0,1036,1035,1,0,0,0,1036,1037,1,0,0,0,1037,1039,1,0,0,0,1038,1040,
        7,2,0,0,1039,1038,1,0,0,0,1040,1041,1,0,0,0,1041,1039,1,0,0,0,1041,
        1042,1,0,0,0,1042,190,1,0,0,0,1043,1045,7,5,0,0,1044,1043,1,0,0,
        0,1045,192,1,0,0,0,1046,1050,5,36,0,0,1047,1050,3,191,95,0,1048,
        1050,7,6,0,0,1049,1046,1,0,0,0,1049,1047,1,0,0,0,1049,1048,1,0,0,
        0,1050,194,1,0,0,0,1051,1054,3,193,96,0,1052,1054,3,185,92,0,1053,
        1051,1,0,0,0,1053,1052,1,0,0,0,1054,196,1,0,0,0,1055,1057,5,13,0,
        0,1056,1055,1,0,0,0,1056,1057,1,0,0,0,1057,1058,1,0,0,0,1058,1060,
        5,10,0,0,1059,1056,1,0,0,0,1060,1061,1,0,0,0,1061,1059,1,0,0,0,1061,
        1062,1,0,0,0,1062,198,1,0,0,0,1063,1065,7,7,0,0,1064,1063,1,0,0,
        0,1065,1066,1,0,0,0,1066,1064,1,0,0,0,1066,1067,1,0,0,0,1067,1068,
        1,0,0,0,1068,1069,6,99,0,0,1069,200,1,0,0,0,1070,1074,5,35,0,0,1071,
        1073,8,8,0,0,1072,1071,1,0,0,0,1073,1076,1,0,0,0,1074,1072,1,0,0,
        0,1074,1075,1,0,0,0,1075,1077,1,0,0,0,1076,1074,1,0,0,0,1077,1078,
        6,100,0,0,1078,202,1,0,0,0,1079,1080,5,47,0,0,1080,1081,5,47,0,0,
        1081,1085,1,0,0,0,1082,1084,8,8,0,0,1083,1082,1,0,0,0,1084,1087,
        1,0,0,0,1085,1083,1,0,0,0,1085,1086,1,0,0,0,1086,1088,1,0,0,0,1087,
        1085,1,0,0,0,1088,1089,6,101,0,0,1089,204,1,0,0,0,1090,1091,5,47,
        0,0,1091,1092,5,42,0,0,1092,1096,1,0,0,0,1093,1095,9,0,0,0,1094,
        1093,1,0,0,0,1095,1098,1,0,0,0,1096,1097,1,0,0,0,1096,1094,1,0,0,
        0,1097,1099,1,0,0,0,1098,1096,1,0,0,0,1099,1100,5,42,0,0,1100,1101,
        5,47,0,0,1101,1102,1,0,0,0,1102,1103,6,102,0,0,1103,206,1,0,0,0,
        23,0,926,928,934,936,944,947,952,957,963,965,1032,1036,1041,1044,
        1049,1053,1056,1061,1066,1074,1085,1096,1,0,1,0
    ];

    private static __ATN: antlr.ATN;
    public static get _ATN(): antlr.ATN {
        if (!GeoTortueLexer.__ATN) {
            GeoTortueLexer.__ATN = new antlr.ATNDeserializer().deserialize(GeoTortueLexer._serializedATN);
        }

        return GeoTortueLexer.__ATN;
    }


    private static readonly vocabulary = new antlr.Vocabulary(GeoTortueLexer.literalNames, GeoTortueLexer.symbolicNames, []);

    public override get vocabulary(): antlr.Vocabulary {
        return GeoTortueLexer.vocabulary;
    }

    private static readonly decisionsToDFA = GeoTortueLexer._ATN.decisionToState.map( (ds: antlr.DecisionState, index: number) => new antlr.DFA(ds, index) );
}